import type { PromobarSlideNavigation } from '../types';

export const getNavigationURL = (navigationObject?: PromobarSlideNavigation): string => {
    if (!navigationObject) {
        return '';
    }

    if ('settings' in navigationObject) {
        return navigationObject.settings?.url;
    }

    return navigationObject.url;
};
